import { render, staticRenderFns } from "./InstructorCard.vue?vue&type=template&id=1546932d&scoped=true"
import script from "./InstructorCard.vue?vue&type=script&lang=js"
export * from "./InstructorCard.vue?vue&type=script&lang=js"
import style0 from "./InstructorCard.vue?vue&type=style&index=0&id=1546932d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1546932d",
  null
  
)

export default component.exports